import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
  
})
export class FooterComponent implements OnInit {
  
  constructor(public router: Router,) { }
  scrollTo(sectionId: string){
    setTimeout(()=>{
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  },50)
  }
  ngOnInit(): void {
  }
}
